// function featureResize(){
// 	if ($(window).width() < 768) {
// 		$('.index-banner-con').css({
// 			'padding-bottom' : $('.index-banner-text').outerHeight() 
// 		});
// 	}
// }

// $(window).on('resize',function(){
// 	$('.index-banner-con').css({
// 		'padding-bottom' : '' 
// 	});

// 	featureResize();
// });

// $(window).on('load',function(){
// 	featureResize();
// });

$('.index-banner-godown').on('click',function(event){
	event.preventDefault();

	$('html,body').animate({
		scrollTop: $(".index-banner-con").outerHeight()},
		'slow');
});

$(window).on('scroll mousewheel',function(){
	st = $(window).scrollTop();

	if (st > hh ) {
		$('header').addClass('fixed');
	} else {
		$('header').removeClass('fixed');
	}
});